import { OptionData } from "@/components/form-control";
import { CityContext } from "@/contexts/city-context-provider";
import { DecreeCategory } from "@/types/gql/graphql";
import { useQueryDecreesPaginated } from "@/modules/restriction/hooks/use-query-decree-file";
import { DecreeFilterList, PaginatedDecreeArgs } from "@/types/decree.type";
import { SortOrder } from "@/types/gql/graphql";
import { useContext, useEffect, useMemo, useRef, useState } from "react";

const paramsDefault: PaginatedDecreeArgs = {
  cityId: "",
  pageIndex: 1,
  pageSize: 6,
  sortField: "publishedDate",
  sortOrder: SortOrder.Desc,
  filter: [
    {
      field: "text",
      value: "",
    },
    {
      field: "category",
      value: DecreeCategory.Temporary,
    },
  ],
};

export type QueryDecreeInfiniteProps = { categories?: DecreeCategory[]; required?: boolean };

export const useQueryDecreeInfinite = (props: QueryDecreeInfiniteProps) => {
  const { currentCity } = useContext(CityContext);
  const initialParams = useMemo((): PaginatedDecreeArgs => {
    const filter: DecreeFilterList = [
      {
        field: "text",
        value: "",
      },
    ];
    if (props.categories !== undefined) {
      filter.push({
        field: "category",
        value: props.categories.join(","),
      });
    }

    return {
      ...paramsDefault,
      filter: filter,
    };
  }, [props]);
  const [decreeParams, setDecreeParams] = useState<PaginatedDecreeArgs>({
    ...paramsDefault,
  });
  const [listDecisionFile, setListDecisionFile] = useState<OptionData<string>[]>([]);
  const previousCityIdRef = useRef<string>();

  useEffect(() => {
    if (currentCity?.id && currentCity.id !== previousCityIdRef.current) {
      setDecreeParams({
        ...initialParams,
        cityId: currentCity.id,
      });
      previousCityIdRef.current = currentCity.id;
    }
  }, [currentCity?.id, initialParams]);

  const { decreeData, isLoading } = useQueryDecreesPaginated({ ...decreeParams });

  useEffect(() => {
    const newDecrees = decreeData.results.map((item) => ({ value: item.id, label: item.name }));
    if (decreeParams.pageIndex === 1) {
      setListDecisionFile(newDecrees);
    } else {
      setListDecisionFile((preValue) => [...preValue, ...newDecrees]);
    }
  }, [decreeData, decreeParams.pageIndex]);

  return { listDecisionFile, isLoading, setDecreeParams, decreeParams, totalPages: decreeData.totalPages };
};
